<template>
    <div>
        <div v-if="filterBauherr.length">
            <table>
                <tbody>
                    <tr class="table-head">
                        <th scope="row">Bauherr</th>
                        <th scope="row">Bauvorhaben</th>
                        <th scope="row">Adresse</th>
                        <th scope="row">Auftraggeber</th>
                        <th class="highlight" scope="row">Auftragsdatum &darr;</th>
                        <th scope="row">Details</th>
                    </tr>
                    <tr v-for="(baustelle, index) in filterBauherr" v-bind:key="index">
                        <td>{{ baustelle.bauherr}}</td>
                        <td>{{ baustelle.bvh}}</td>
                        <td>{{ baustelle.adresse}}</td>
                        <td>{{ baustelle.auftraggeber}}</td>
                        <td>{{ baustelle.auftragsdatum | formatStrDate}}</td>
                        <td class="button-col">
                          <router-link
                            class="button arrow-button"
                            :to="{ name: 'Detail', params: { id: baustelle.id }}">
                              <span class="material-icons">arrow_forward</span>
                          </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-else>
            <table v-if="filterAuftr.length">
                <tbody>
                    <tr>
                        <th scope="row">Bauherr</th>
                        <th scope="row">Bauvorhaben</th>
                        <th scope="row">Adresse</th>
                        <th scope="row">Auftraggeber</th>
                        <th class="highlight" scope="row">Auftragsdatum &darr;</th>
                    </tr>
                    <tr v-for="(baustelle, index) in filterAuftr" v-bind:key="index">
                        <td>{{ baustelle.bauherr}}</td>
                        <td>{{ baustelle.bvh}}</td>
                        <td>{{ baustelle.adresse}}</td>
                        <td>{{ baustelle.auftraggeber}}</td>
                        <td>{{ baustelle.auftragsdatum | formatStrDate}}</td>
                        <td><router-link class="button" :to="{ name: 'Detail', params: { id: baustelle.id }}">Details</router-link></td>
                    </tr>
                </tbody>
            </table>
        </div>
    
    </div>  
</template>

<script>
import moment from "moment";

export default {
  props: ["filterAuftr", "bauherrFilter", "filterBauherr"],
  filters: {
    formatStrDate(date) {
      return moment(date).format("DD.MM.YYYY");
    }
  }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-top: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 12px;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

td,
th {
  border-right: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

td:last-of-type,
th:last-of-type {
  border-right: none;
}

tr {
  height: 40px;
}

tr:nth-child(even) {
  background: #e3e3e4;
}

.button-col {
  text-align: center;
}

tfoot td {
  border: none;
  background: white;
  padding-left: 0;
}

.highlight {
  color: #2c3e50;
  background-color: #eeeeee;
  white-space: nowrap;
}

.material-icons {
  vertical-align: middle;
  font-size: 20px;
}

.arrow-button {
  padding: 5px;
  border-radius: 100px;
  font-size: 15px;
}
</style>